module.exports = __webpack_public_path__ + "img/CS48Q-中_05.837ef245.jpg";